import { ElLoading, ElMessage } from 'element-plus';
import WorksForSaleApi from '@/frontend/api/worksForSale';
import AuthorsApi from '@/frontend/api/authors';
import handlerErrorRequest from '@/frontend/functions/handlerErrorRequest';
import InputPhoneComponent from '@/common/components/InputPhoneComponent';
import setMetas from '@/frontend/functions/setMetas';
import Yandex from "@/frontend/classes/yandex";
export default {
  name: "SellWorkPage",
  components: {
    InputPhoneComponent
  },

  data() {
    return {
      form: {
        author_id: 0
      },
      authors: [],
      image: '',
      finish: false,
      agreePolicy: false
    };
  },

  created() {
    setMetas('sell-work');
  },

  beforeMount() {
    AuthorsApi.get({
      fields: ['id', 'name'].join(','),
      'per-page': 100000
    }).then(response => this.authors = response.items).catch(handlerErrorRequest);
  },

  mounted() {
    const s = document.createElement("script");
    s.innerHTML = `
    $('.ui-selectmenu-button.ui-selectmenu-button-closed.ui-corner-all.ui-button.ui-widget').remove();
   $('.styled').selectmenu({
    position: {
      my: "left top", // default
      at: "left bottom", // default
      // "flip" will show the menu opposite side if there
      // is not enough available space
      collision: "flip",  // default is ""
    },
    appendTo: 'section.main'
  });
  `;
    document.body.getElementsByClassName('main')[0].appendChild(s);
  },

  methods: {
    handlerSubmit() {
      let Form = new FormData(),
          loader;

      if (!this.agreePolicy) {
        ElMessage({
          message: 'Подтвердите согласие с политикой обработки данных',
          type: 'warning'
        });
        return;
      }

      this.form.author_id = this.$refs.authorId.value;
      loader = ElLoading.service({
        lock: false,
        text: 'Загрузка'
      });

      for (let key in this.form) {
        if (key === 'photo') Form.append('uploadImage', this.form[key]);else Form.append(key, this.form[key]);
      }

      WorksForSaleApi.create(Form).then(response => {
        Yandex.metrika('reachGoal', 'itsok1');
        ElMessage({
          message: response.message,
          type: 'success'
        });
        this.finish = true;
      }).catch(handlerErrorRequest).finally(() => {
        loader.close();
      });
    },

    handlerSelectPhoto(uploadFile) {
      let rawFile = uploadFile.raw;

      if (rawFile.type !== 'image/jpeg' && rawFile.type !== 'image/png') {
        ElMessage.error('Допустимые фото формата JPEG или PNG');
        return false;
      }

      this.form.photo = uploadFile.raw;
      this.image = URL.createObjectURL(uploadFile.raw);
      return true;
    }

  }
};